import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ReviewSkeletonComponent} from './skeleton/review-skeleton.component';
import {ReviewReportPage} from './report/review-report.page';
import {ComponentsReviewModule} from './components/components.module';
import {MomentModule} from 'ngx-moment';
import {ReviewRoutingModule} from './review-routing.module';
import {ReviewPage} from './review/review.page';
import {ReviewReportListPage} from './review-report-list/review-report-list.page';
import {TeamModule} from '../team/team.module';
import {PipesModule} from '../../pipes/pipes.module';
import {ReviewFeedbackPage} from './feedback/review-feedback.page';
import {ReviewReportPrintPage} from './report-print/review-report-print.page';
import {ReviewReportOne2OnePage} from './report-one2one/review-report-one2one.page';
import {ReviewReportOne2OnePrintPage} from './report-one2one-print/review-report-one2one-print.page';

@NgModule({
    imports: [
        ReviewRoutingModule,
        CommonModule,
        PipesModule,
        FormsModule,
        IonicModule,
        ComponentsModule,
        TranslateModule.forChild(),
        NgOptimizedImage,
        ComponentsReviewModule,
        MomentModule,
        TeamModule
    ],
    declarations: [
        ReviewPage,
        ReviewFeedbackPage,
        ReviewReportPage,
        ReviewReportPrintPage,
        ReviewReportOne2OnePrintPage,
        ReviewReportOne2OnePage,
        ReviewSkeletonComponent,
        ReviewReportListPage,
    ]
})
export class ReviewModule {
}
